export const exportData = `query ($filter: ExportPCXRequest){
  export(filter: $filter) {
          name,
          content
      }
  }`;
